// Store para controlar los modales de SearchInput
export const useSearchModalsStore = defineStore('searchModals', () => {
  const openDest = ref(false)
  const openCalendar = ref(false)

  function openDestinationModal() {
    openDest.value = true
  }

  function openCalendarModal() {
    openCalendar.value = true
  }

  function closeDestinationModal() {
    openDest.value = false
  }

  function closeCalendarModal() {
    openCalendar.value = false
  }

  return {
    openDest,
    openCalendar,
    openDestinationModal,
    openCalendarModal,
    closeDestinationModal,
    closeCalendarModal
  }
})
